// extracted by mini-css-extract-plugin
export default {"my_books_tab_item_container":"MyBooksTab_my_books_tab_item_container__LJqw4"};